import { render, staticRenderFns } from "./HumanCapitalDisabilitiesRateInput.vue?vue&type=template&id=52fde028&scoped=true&"
import script from "./HumanCapitalDisabilitiesRateInput.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalDisabilitiesRateInput.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalDisabilitiesRateInput.vue?vue&type=style&index=0&id=52fde028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fde028",
  null
  
)

export default component.exports